export default "__VITE_ASSET__CafKSsAO__"